<script setup lang="ts">
import { useCarousel } from './useCarousel'
import type { WithClassAsProps } from './interface'
//import { cn } from '~/utils/cn'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<WithClassAsProps & { containerClass?: string }>()

const { carouselRef, orientation } = useCarousel()
</script>

<template>
  <div ref="carouselRef" :class="cn('overflow-hidden', props.containerClass)" >
    <div
      :class="
        cn(
          'flex',
          orientation === 'horizontal' ? '-ml-4' : '-mt-4 flex-col',
          props.class,
        )"
      v-bind="$attrs"
    >
      <slot />
    </div>
  </div>
</template>
